import { FormControl, IconButton, InputAdornment, InputLabel, OutlinedInput } from "@mui/material";
import React, { useState } from "react";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

export const ContasenaOculta = ({
	contrasena,
	setContrasena,
	label = "Contraseña",
	inputId = "outlined-adornment-password",
}) => {
	const [showPassword, setShowPassword] = useState(false);

	const handleClickShowPassword = () => setShowPassword((show) => !show);

	const handleMouseDownPassword = (event) => {
		event.preventDefault();
	};

	return (
		<FormControl variant="outlined" style={{ minWidth: "100%" }}>
			<InputLabel htmlFor={inputId} color="primary">
				{label}
			</InputLabel>
			<OutlinedInput
				name="password"
				color="primary"
				id={inputId}
				type={showPassword ? "text" : "password"}
				value={contrasena}
				endAdornment={
					<InputAdornment position="end">
						<IconButton
							aria-label="toggle password visibility"
							onClick={handleClickShowPassword}
							onMouseDown={handleMouseDownPassword}
							edge="end"
						>
							{showPassword ? <VisibilityOff /> : <Visibility />}
						</IconButton>
					</InputAdornment>
				}
				label={label}
				onChange={(event) => setContrasena(event.target.value)}
			/>
		</FormControl>
	);
};
